import { atomFamily } from 'recoil';

/**
 * Tracks the number of photos currently being saved to IndexedDB for each task.
 * Keyed by taskId. Used to show saving indicators and disable photo-taking buttons.
 */
export const pendingPhotoSavesState = atomFamily<number, string>({
  key: 'pendingPhotoSavesState',
  default: 0,
});
